import store from "@/store";

export async function modifyShortcut(shortcut) {
  let bfsTestList = store.getters["orderTest/tests/bfsTestList"];
  let nonOrderableTestIds = store.getters["orderTest/tests/nonOrderableTestIds"];

  let testIdList = [];
  let discountPanelIdList = [];
  let customPanelIdList = [];
  let xChooseYIdList = [];
  shortcut.bundles?.forEach(bundle => {
    if (bundle.bundle_type === "discountpanel") {
      discountPanelIdList.push(bundle.bundle_id);
    } else if (bundle.bundle_type === "custompanel") {
      customPanelIdList.push(bundle.bundle_id);
    } else if (bundle.bundle_type === "xchoosey") {
      let { selected_test_ids, supplement_test_ids } = bundle.meta_data;
      xChooseYIdList.push({
        bundleId: bundle.bundle_id,
        selectedZoomerIdList: selected_test_ids ? selected_test_ids : [],
        selectedSupplementIdList: supplement_test_ids ? supplement_test_ids : []
      });
    }
  });
  shortcut.tests?.forEach(test => {
    let parentId = test.meta_data.parent_id;
    let testId = parentId ? [test.test_id, parentId].join("_") : test.test_id;
    // check if the test exists
    if (bfsTestList.find(test => test.id === testId)) {
      testIdList.push(testId);
    } else {
      // check if the test is a duplicate test(without distinguish id)
      // if so, add the first found duplicate test
      let testNode = bfsTestList.find(node => node.value.originalId === testId);
      if (testNode) {
        testIdList.push(testNode.id);
      }
    }
  });
  let modifiedShortcut = {
    shortcutName: shortcut.shortcut_name,
    testIdList,
    discountPanelIdList,
    customPanelIdList,
    xChooseYIdList,
    category: "shortcut",
    id: shortcut.shortcut_id,
    isSelect: false,
    isOpenShortcutDialog: false,
    isDbs: shortcut.is_dbs,
    isClinic: shortcut.is_practice
  };
  await store.dispatch("orderTest/favorites/setShortcutSampleTypes", modifiedShortcut);
  await store.dispatch("orderTest/favorites/setShortcutPriceAndContents", { shortcutFrontend: modifiedShortcut });
  /**
   * VP-8210 hardcode: if the shortcut has connective tissue panel (id: 18), 
   * then add it to testIdList & mark it as "needAction"
   * **************************************************
   * 04/04/2025 update: VP-9922 hardcode
   * if the shortcut has hormones test (id: 59, 194), then mark it as "needAction"
   * *************************************************
   * 10/08/2025 update: replace hardcode with nonMicronutrient list
   * the list now includes ctp, hormones, cardiaX, cardioGenetic
   */
  let xChooseYTestIds = modifiedShortcut.xChooseYIdList.map(item => item.selectedZoomerIdList.concat(item.selectedSupplementIdList)).flat();
  let { nonMicronutrient } = nonOrderableTestIds;
  if (modifiedShortcut.testIdList.concat(xChooseYTestIds).some(id => nonMicronutrient.includes(id))) {
    modifiedShortcut.needAction = true;
  }
  return modifiedShortcut;
}